import React from 'react';

import { createRoot } from 'react-dom/client';
import { NavLink, BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { NavLinkContext } from '@ergeon/core-components';
import UpcomingFeaturesHandler from '@ergeon/core-components/exports/UpcomingFeaturesHandler';
import { ThemeProvider } from '@ergeon/help-components';

import HomePage from 'components/HomePage';
import Layout from 'components/Layout';
import NotFoundPage from 'components/NotFoundPage';
import CurrentNodeProvider from 'components/wiki/CurrentNodeProvider';
import WikiLandingPage from 'components/wiki/landing/WikiLandingPage';
import NodeKeyRedirect from 'components/wiki/NodeKeyRedirect';
import WikiNodePage from 'components/wiki/node/WikiNodePage';
import ScrollToTopOnNavigation from 'components/wiki/ScrollToTopOnNavigation';
import WikiSearchPage from 'components/wiki/search/WikiSearchPage';
import WikiPaletteProvider from 'components/wiki/WikiPaletteProvider';
import store from 'flux/store';

import './tailwind.css';

const App = (
  <Provider store={store}>
    <ThemeProvider>
      <BrowserRouter>
        <UpcomingFeaturesHandler>
          <NavLinkContext.Provider value={NavLink}>
            <NodeKeyRedirect />
            <ScrollToTopOnNavigation />
            <CurrentNodeProvider>
              <WikiPaletteProvider>
                <Layout>
                  <Routes>
                    <Route element={<HomePage />} path="/" />
                    <Route element={<WikiLandingPage />} path="/help" />
                    <Route element={<WikiSearchPage />} path="/help/search" />
                    <Route element={<WikiNodePage />} path="/help/:nodeKey" />
                    <Route element={<NotFoundPage />} path="*" />
                  </Routes>
                </Layout>
              </WikiPaletteProvider>
            </CurrentNodeProvider>
          </NavLinkContext.Provider>
        </UpcomingFeaturesHandler>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(App);
